export const phoneTypesOptions = [
  { value: 'mobile', label: 'Mobile' },
  { value: 'home', label: 'Home' },
  { value: 'office', label: 'Office' },
]
